import { gql, TypedDocumentNode } from '@apollo/client';

import { TimeUnitEnum } from '@libs/backend-common';
import { DefaultApiResponse } from '@libs/graphql';

export type GetCardTransactionsInfoForUserRes = {
  getCardTransactionsInfoForUser: {
    cardTransactionAllowed: boolean;
    cardTransactionEnableDate: string;
    timeAmount?: number;
    timeUnit?: TimeUnitEnum;
    cardAddAllowed?: boolean;
    cardDepositAllowed?: boolean;
  };
};

export const getCardTransactionsInfoForUserQuery: TypedDocumentNode<
  DefaultApiResponse<GetCardTransactionsInfoForUserRes>
> = gql`
  query GetCardTransactionsInfoForUserV2 {
    getCardTransactionsInfoForUser: getCardTransactionsInfoForUserV2 {
      cardTransactionAllowed
      cardTransactionEnableDate
    }
  }
`;
